const isFileObject = (obj: unknown) =>
  Array.isArray(obj) && obj[0] && obj[0].name && obj[0].size && obj[0].type;

export default isFileObject;
